/*
  MELYLA Kennzahlen: Zahlen zaehlen beim Hereinscrollen von 0 hoch.

  Die Endzahl steht immer schon im HTML. Google, Leser ohne JavaScript und
  alle mit "Bewegung reduzieren" sehen sie sofort - dieses Skript macht nur
  die Bewegung davor.

  Markup:  <span data-melyla-zahl="5000" data-melyla-dezimal="0">5.000</span>
     oder  <div data-melyla-zaehle>bis 30 %</div>   (Plaketten mit freiem Text)

  Genutzt von den Plaketten in melyla-funnel-problem und melyla-funnel-loesung.

  Wird von jeder Sektion mit Kennzahlen eingebunden. Zwei script-Tags mit
  derselben Adresse laufen zweimal, darum die Sperre ueber window.melylaHochzaehlen:
  Der zweite Lauf sucht nur nach neuen Zahlen. Dasselbe beim Nachrendern im
  Theme-Editor (shopify:section:load).
*/
(function () {
  if (window.melylaHochzaehlen) {
    window.melylaHochzaehlen.suchen(document);
    return;
  }

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DAUER = 1400;

  function format(wert, dezimal) {
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: dezimal,
      maximumFractionDigits: dezimal
    }).format(wert);
  }

  function zaehlen(el) {
    var ziel = parseFloat(el.dataset.melylaZahl);
    var dezimal = Number(el.dataset.melylaDezimal || 0);
    var beginn = null;

    function schritt(zeit) {
      if (beginn === null) beginn = zeit;
      var anteil = Math.min((zeit - beginn) / DAUER, 1);
      /* Erst schnell, dann langsam auslaufen - wie ein Zaehlwerk */
      var weich = 1 - Math.pow(1 - anteil, 3);
      if (anteil < 1) {
        el.textContent = format(ziel * weich, dezimal);
        window.requestAnimationFrame(schritt);
      } else {
        /* Am Ende exakt der Text aus dem HTML, nicht der gerechnete */
        el.textContent = el.dataset.melylaEnde;
      }
    }
    window.requestAnimationFrame(schritt);
  }

  var beobachter = null;
  if (!ruhig && 'IntersectionObserver' in window) {
    beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        beobachter.unobserve(e.target);
        zaehlen(e.target);
      });
    }, { threshold: 0.6 });
  }

  /* Freier Text wie "bis 30 %" oder "27 → 16" (data-melyla-zaehle): Die
     letzte Zahl darin wird zur zaehlenden Zahl, der Rest bleibt stehen. */
  function zahlAusText(el) {
    el.dataset.melylaZahlBereit = '1';
    var text = el.textContent.trim();
    var treffer = text.match(/\d{1,3}(?:\.\d{3})+|\d+(?:,\d+)?/g);
    if (!treffer) return;
    var zahl = treffer[treffer.length - 1];
    var stelle = text.lastIndexOf(zahl);
    var span = document.createElement('span');
    span.textContent = zahl;
    span.dataset.melylaZahl = zahl.replace(/\./g, '').replace(',', '.');
    span.dataset.melylaDezimal = zahl.indexOf(',') >= 0 ? zahl.split(',')[1].length : 0;
    /* Feste Breite, damit die Plakette beim Zaehlen nicht wackelt */
    span.style.display = 'inline-block';
    span.style.minWidth = zahl.length + 'ch';
    span.style.fontVariantNumeric = 'tabular-nums';
    el.textContent = '';
    el.appendChild(document.createTextNode(text.slice(0, stelle)));
    el.appendChild(span);
    el.appendChild(document.createTextNode(text.slice(stelle + zahl.length)));
  }

  function suchen(wurzel) {
    if (!beobachter || !wurzel || !wurzel.querySelectorAll) return;
    Array.prototype.forEach.call(
      wurzel.querySelectorAll('[data-melyla-zaehle]:not([data-melyla-zahl-bereit])'),
      zahlAusText
    );
    var zahlen = wurzel.querySelectorAll('[data-melyla-zahl]:not([data-melyla-zahl-bereit])');
    Array.prototype.forEach.call(zahlen, function (el) {
      var ziel = parseFloat(el.dataset.melylaZahl);
      if (isNaN(ziel)) return;
      el.dataset.melylaZahlBereit = '1';
      el.dataset.melylaEnde = el.textContent;
      el.textContent = format(0, Number(el.dataset.melylaDezimal || 0));
      beobachter.observe(el);
    });
  }

  window.melylaHochzaehlen = { suchen: suchen };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { suchen(document); });
  } else {
    suchen(document);
  }
  document.addEventListener('shopify:section:load', function (e) { suchen(e.target); });
})();
